import { render, staticRenderFns } from "./PortfolioSectors.vue?vue&type=template&id=4d024c5c"
import script from "./PortfolioSectors.vue?vue&type=script&lang=js"
export * from "./PortfolioSectors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports